module.exports = __webpack_public_path__ + "img/secretaria.0241acca.png";